import * as Immutable from 'immutable';
import {
  // SET_NAVIGATION_DRAWER_OPEN_REQUESTED,
  SET_NAVIGATION_DRAWER_OPEN_COMPLETED,
} from '../../actions/navigationdrawer/types';

const schema = {
  open: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NAVIGATION_DRAWER_OPEN_COMPLETED:
      return state.set('open', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
